<template>
  <div class="ui form">
    <div class="two fields">
      <div class="field">
        <label for="">{{ $t("name") }}</label>
        <input type="text" name="name" v-model="setup.name" />
      </div>
      <div class="field">
        <label for="">{{ $t("grace days") }}</label>
        <input type="text" name="grace_days" v-model="setup.grace_days" />
      </div>
    </div>
    <div class="three fields">
      <div class="field">
        <label>{{ $t("start date") }}</label>
        <div class="ui calendar" ref="rangestart">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text" :placeholder="$t('start date')" />
          </div>
        </div>
      </div>
      <div class="field">
        <label>{{ $t("end date") }}</label>
        <div class="ui calendar" ref="rangeend">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text" :placeholder="$t('end date')" />
          </div>
        </div>
      </div>
      <div class="field">
        <label>{{ $t("last redeem date") }}</label>
        <div class="ui calendar" ref="redeem_date">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text" :placeholder="$t('last redeem date')" />
          </div>
        </div>
      </div>
    </div>
    <div class="field">
      <label for="">{{ $t("assets link") }}</label>
      <input type="text" name="assets_link" v-model="setup.assets_link" />
    </div>
    <div class="field">
      <label for="">{{ $t("stores") }}</label>
      <div
        class="ui fluid multiple search selection dropdown"
        ref="stores_dropdown"
      >
        <input type="hidden" name="stores" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select stores") }}</div>
        <div class="menu"></div>
      </div>
    </div>
    <div class="field">
      <label for="">{{ $t("graphic cards") }}</label>
      <div
        class="ui fluid multiple search selection dropdown"
        ref="graphic_cards_dropdown"
      >
        <input type="hidden" name="graphic_cards" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select graphic cards") }}</div>
        <div class="menu"></div>
      </div>
    </div>
    <div
      class="field"
      v-show="graphic_cards_options && graphic_cards_options.length"
    >
      <label for="">{{ $t("graphic cards options") }}</label>
      <div>
        <div class="ui four cards">
          <div
            class="card"
            v-for="(gc, idx) in graphic_cards_options"
            :key="idx"
          >
            <div class="content">
              <div class="header">{{ gc.card_name }}</div>
              <div class="description">
                <div class="ui form">
                  <div class="grouped fields">
                    <label>{{ $t("availability") }}</label>
                    <div
                      class="field"
                      v-bind:class="{ disabled: !gc.desktop_enabled }"
                    >
                      <div class="ui toggle checkbox">
                        <input
                          type="checkbox"
                          name="desktop_available"
                          v-model="graphic_cards_options[idx].desktop_available"
                        />
                        <label>{{ $t("desktop") }}</label>
                      </div>
                    </div>
                    <div
                      class="field"
                      v-bind:class="{ disabled: !gc.laptop_enabled }"
                    >
                      <div class="ui toggle checkbox">
                        <input
                          type="checkbox"
                          name="laptop_available"
                          v-model="graphic_cards_options[idx].laptop_available"
                        />
                        <label>{{ $t("laptop") }}</label>
                      </div>
                    </div>
                    <div
                      class="field"
                      v-bind:class="{ disabled: !gc.card_enabled }"
                    >
                      <div class="ui toggle checkbox">
                        <input
                          type="checkbox"
                          name="card_available"
                          v-model="graphic_cards_options[idx].card_available"
                        />
                        <label>{{ $t("card") }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- {{ gc }} -->
              </div>
            </div>
          </div>
        </div>
        <!-- <pre>{{ graphic_cards_options }}</pre> -->
      </div>
    </div>
  </div>
</template>

<script>
import { error_toast, local_api } from "@/utils";
export default {
  name: "BundleModalGeneral",
  data() {
    return {
      graphic_cards_options: [],
    };
  },
  props: {
    setup: Object,
    id: String,
  },
  mounted() {
    let vm = this;
    setTimeout(() => {
      window.jQuery(vm.$refs.rangestart).calendar({
        type: "date",
        endCalendar: window.jQuery(vm.$refs.rangeend),
        onChange(value) {
          vm.setup.start_date = value;
        },
      });
      window.jQuery(vm.$refs.rangeend).calendar({
        type: "date",
        startCalendar: window.jQuery(vm.$refs.rangestart),
        onChange(value) {
          vm.setup.end_date = value;
        },
      });

      window.jQuery(vm.$refs.redeem_date).calendar({
        type: "date",
        onChange(value) {
          vm.setup.last_redeem_date = value;
        },
      });
    }, 200);

    // Graphic cards dropdown
    local_api(vm, "post", "/nvidia_bundle/graphic_card/do-get-list")
      .then((list) => {
        let vls = list.map((itm) => {
          return { name: itm.setup.name, value: itm.graphic_card_id };
        });
        window
          .jQuery(vm.$refs.graphic_cards_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.$emit("update_cards", value);
              let _vls = value.split(",").map((c) => {
                let existingTrgt = vm.graphic_cards_options.find(
                  (g) => String(g.card_id) == String(c),
                );

                let trgt = list.find((l) => l.graphic_card_id == c);
                if (trgt) {
                  return {
                    card_id: c,
                    card_name: trgt.setup.name,
                    desktop_enabled: trgt.setup.for_desktop,
                    desktop_available: existingTrgt
                      ? existingTrgt.desktop_available
                      : false,
                    laptop_enabled: trgt.setup.for_laptop,
                    laptop_available: existingTrgt
                      ? existingTrgt.laptop_available
                      : false,
                    card_enabled: trgt.setup.for_discrete,
                    card_available: existingTrgt
                      ? existingTrgt.card_available
                      : false,
                  };
                } else {
                  return {};
                }
              });
              vm.graphic_cards_options = _vls;
            },
          });
      })
      .catch((err) => {
        error_toast(err);
      });

    // Stores dropdown
    local_api(vm, "post", "/nvidia_bundle/store/do-get-list")
      .then((list) => {
        let vls = list.map((itm) => {
          return { name: itm.setup.name, value: itm.store_id };
        });
        window
          .jQuery(vm.$refs.stores_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.$emit("update_stores", value);
            },
          });

        setTimeout(() => {
          if (!vm.id) {
            //Auto-assign stores
            let auto = list
              .filter((l) => {
                return l.setup.auto_assign_bundles;
              })
              .map((l) => {
                return { name: l.setup.name, value: l.store_id };
              });
            if (auto && auto.length) {
              window.jQuery(vm.$refs.stores_dropdown).dropdown(
                "set selected",
                auto.map((x) => {
                  return x.value;
                }),
              );
            }
          }
        }, 500);
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  methods: {
    getData() {
      return this.graphic_cards_options;
    },
    setData(bundle) {
      let vm = this;
      if (bundle.setup.start_date) {
        window
          .jQuery(vm.$refs.rangestart)
          .calendar("set date", bundle.setup.start_date);
      }
      if (bundle.setup.end_date) {
        window
          .jQuery(vm.$refs.rangeend)
          .calendar("set date", bundle.setup.end_date);
      }
      if (bundle.setup.last_redeem_date) {
        window
          .jQuery(vm.$refs.redeem_date)
          .calendar("set date", bundle.setup.last_redeem_date);
      }
      if (bundle.setup.cards) {
        let cardssplt = bundle.setup.cards.split(",");
        window
          .jQuery(vm.$refs.graphic_cards_dropdown)
          .dropdown("set selected", cardssplt);
      }
      if (bundle.setup.stores) {
        let bundlessplt = bundle.setup.stores.split(",");
        bundlessplt = bundlessplt.filter((s) => s);
        window
          .jQuery(vm.$refs.stores_dropdown)
          .dropdown("set selected", bundlessplt);
      }

      if (bundle.setup.graphic_cards_options) {
        vm.graphic_cards_options = bundle.setup.graphic_cards_options;
      }
    },
  },
};
</script>
